import { render, staticRenderFns } from "./color-toolbar.vue?vue&type=template&id=0676413d&scoped=true"
import script from "./color-toolbar.vue?vue&type=script&lang=js"
export * from "./color-toolbar.vue?vue&type=script&lang=js"
import style0 from "./color-toolbar.vue?vue&type=style&index=0&id=0676413d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0676413d",
  null
  
)

export default component.exports